import { Injectable } from '@angular/core';
import { estado } from '../interfaces/estado';
@Injectable({
  providedIn: 'root'
})
export class EstadoService {

  constructor() { }

  get():estado[]{
    let estados:estado[]=new Array();
    estados.push({id:7, descripcion:'Conforme'})
    estados.push({id:4, descripcion:'Rechazada'})
    estados.push({id:0, descripcion:'Todas'})
    return estados;
  }
}
